import React from 'react';

import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { G2Badge } from '@/components/integrations/g2';

export type G2BadgeSBProps = object;

export function G2BadgeSB({ block }: BlockComponentModel<G2BadgeSBProps>) {
  return <G2Badge {...block} />;
}
